module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Image_16"],"path":[{"$":{"d":"M5,5A1,1,0,1,0,4,6,1,1,0,0,0,5,5M5,7.5,7.78,9.19,10,6l3,6H3ZM16,15H0V1H16ZM2,13H14V3H2Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Image_16.svg
// module id = B2vq
// module chunks = 1